enum EventType {
  APPOINTMENT_GUIDE_OPENED = 'Appointment Guide Opened',
  APPOINTMENT_GUIDES_BUTTON_CLICKED = 'Appointment Guides Button Clicked',
  APPOINTMENT_TRANSCRIPT_CRITERION_DETAIL_OPENED = 'Appointment Transcript Criterion Detail Opened',
  APPOINTMENT_TRANSCRIPT_CRITERION_VIEWED = 'Appointment Transcript Criterion Viewed',
  APPOINTMENT_TRANSCRIPT_SCORE_EXPANDED = 'Appointment Transcript Score Expanded',
  APPOINTMENT_TRANSCRIPT_SCORE_VIEWED = 'Appointment Transcript Score Viewed',
  CARE_MACHINE_QUICK_VIEW_SHOWN = 'Care Machine Quick View Shown',
  CARE_MACHINE_TAB_CLICKED = 'Care Machine Tab Clicked',
  CARE_MACHINE_TAB_SHOWN = 'Care Machine Tab Shown',
  COMPLETE_OUTCOME_BUTTON_CLICKED = 'Complete Outcome Button Clicked',
  COMPLETE_OUTCOME_BUTTON_OUTCOME_COMPLETED = 'Complete Outcome Button Outcome Completed',
  COUPLING_EDITED = 'Coupling Edited',
  CUSTOMER_FOCUS_REASONS_ADDRESSED = 'Customer Focus Reasons Addressed',
  CUSTOMER_PROFILE_DOWNLOAD_STARTED = 'Customer Profile Download - Started',
  CUSTOMER_PROFILE_DOWNLOAD_SUCCESSFUL = 'Customer Profile Download - Successful',
  CUSTOMER_PROFILE_DOWNLOAD_TIMED_OUT = 'Customer Profile Download - Timed Out',
  CUSTOMER_PROFILE_DOWNLOAD_TOOK_LONGER_THAN_EXPECTED = 'Customer Profile Download - Took Longer Than Expected',
  EDIT_COUPLING_BUTTON_CLICKED = 'Edit Coupling Button Clicked',
  EDIT_NOTE_SERVICE_NOTE_WITH_RELATED_APPOINTMENT = 'Edit Note Service Note With A Related Appointment',
  EXTERNAL_REDIRECT = 'External Redirect',
  FITTING_QUALITY_CRITERION_VIEWED = 'Fitting Quality Criterion Viewed',
  FITTING_QUALITY_SCORE_EXPANDED = 'Fitting Quality Score Expanded',
  FITTING_QUALITY_SCORE_VIEWED = 'Fitting Quality Score Viewed',
  FORM_ABANDONED = 'Form Abandoned',
  FORM_COMPLETED = 'Form Completed',
  FORM_SUBMISSION_FAILED = 'Form Submission Failed',
  INLINE_ADD_NOTE_BUTTON_CLICKED = 'Add Note Button Clicked',
  INLINE_EDIT_NOTE_BUTTON_CLICKED = 'Edit Note Button Clicked',
  INLINE_PIN_UNPIN_NOTE_BUTTON_CLICKED = 'Edit Pin/Unpin Button Clicked',
  NOTE_ADDED = 'Note Added',
  NOTIFICATIONS_BELL_CLICKED = 'Notifications Bell Clicked',
  ORDERS_TAB_CANCEL_SALES_ORDER_BUTTON_CLICKED = 'Orders Tab Cancel Sales Order Button Clicked',
  PAGE_VIEW = 'Page View',
  OPEN_CUSTOMER_DETAILS = 'OPEN_CUSTOMER_DETAILS',
}

export { EventType }
